/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../../buttons/button/button.component.ngfactory';
import * as import2 from '../../buttons/button/button.component';
import * as import3 from '../../orchestration/session.model';
import * as import4 from '../../orchestration/responsive.service';
import * as import5 from '@angular/common';
import * as import6 from '../../ui-elements/card-brand/card-brand.component.ngfactory';
import * as import7 from '../../ui-elements/card-brand/card-brand.component';
import * as import8 from '../../buttons/apple-pay-button/apple-pay-button.component.ngfactory';
import * as import9 from '../../buttons/apple-pay-button/apple-pay-button.component';
import * as import10 from '../../payment/payment.model';
import * as import11 from '../../buttons/google-pay-button/google-pay-button.component.ngfactory';
import * as import12 from '../../buttons/google-pay-button/google-pay-button.component';
import * as import13 from '../../string-utils/possessive.pipe';
import * as import14 from './quick-pay-panel.component';
import * as import15 from '../../order/order.model';
import * as import16 from '../../group-order/group-order.model';
const styles_QuickPayPanelComponent:any[] = ([] as any[]);
export const RenderType_QuickPayPanelComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_QuickPayPanelComponent,
  data: {}
}
);
function View_QuickPayPanelComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'woa-button',[[
        'class',
        'quick-pay-button group-order'
      ]
    ],[
      [
        2,
        'override-flat-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-flat-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-border-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'invisible',
        (null as any)
      ]
      ,
      [
        2,
        'hovered',
        (null as any)
      ]
      ,
      [
        2,
        'native',
        (null as any)
      ]
      ,
      [
        2,
        'woa-button',
        (null as any)
      ]
      ,
      [
        2,
        'tier-first',
        (null as any)
      ]
      ,
      [
        2,
        'tier-second',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-high',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-low',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-affirmative',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-dissuasive',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-negative',
        (null as any)
      ]
      ,
      [
        2,
        'shape-square',
        (null as any)
      ]
      ,
      [
        2,
        'shape-rounded',
        (null as any)
      ]
      ,
      [
        2,
        'shape-oval',
        (null as any)
      ]
      ,
      [
        2,
        'style-flat',
        (null as any)
      ]
      ,
      [
        2,
        'style-outline',
        (null as any)
      ]
      ,
      [
        2,
        'style-raised',
        (null as any)
      ]
      ,
      [
        2,
        'layout-vertical',
        (null as any)
      ]
      ,
      [
        2,
        'layout-horizontal',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('click' === en)) {
        const pd_1:any = ((<any>co.pay.emit(co.PaymentType.GROUP_PAY)) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import1.View_ButtonComponent_0,import1.RenderType_ButtonComponent)),
    import0.ɵdid(245760,(null as any),0,import2.ButtonComponent,[
      import0.ElementRef,
      import3.SessionModel,
      import0.ChangeDetectorRef,
      import4.ResponsiveService
    ]
    ,{
      label: [
        0,
        'label'
      ]
      ,
      translationParams: [
        1,
        'translationParams'
      ]
      ,
      icon: [
        2,
        'icon'
      ]
      ,
      showSpinner: [
        3,
        'showSpinner'
      ]
      ,
      disabled: [
        4,
        'disabled'
      ]

    }
    ,(null as any)),
    import0.ɵppd(1),
    import0.ɵpod(['groupOrderName']),
    import0.ɵpid(131072,import5.AsyncPipe,[import0.ChangeDetectorRef])
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_27:any = (co.showSpinner? 'woa.message.order.initiating': 'woa.button.checkout.payWithGroupOrder');
    const currVal_28:any = ck(v,3,0,import0.ɵunv(v,1,1,ck(v,2,0,import0.ɵnov((<any>v.parent),0),((co.groupOrderModel.preferredTransferTarget == null)? (null as any): co.groupOrderModel.preferredTransferTarget.name))));
    const currVal_29:any = 'users';
    const currVal_30:any = co.showSpinner;
    const currVal_31:any = ((co.disabled || co.sessionModel.timeTestMode) || (import0.ɵunv(v,1,4,import0.ɵnov(v,4).transform(co.OrderEvents.orderInitiationStatus$)) === co.OrderInitiationStatus.INITIATING));
    ck(v,1,0,currVal_27,currVal_28,currVal_29,currVal_30,currVal_31);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).overrideFlatBackgroundColor;
    const currVal_1:any = import0.ɵnov(v,1).overrideFlatForegroundColor;
    const currVal_2:any = import0.ɵnov(v,1).overrideOutlineBackgroundColor;
    const currVal_3:any = import0.ɵnov(v,1).overrideOutlineForegroundColor;
    const currVal_4:any = import0.ɵnov(v,1).overrideOutlineBorderColor;
    const currVal_5:any = import0.ɵnov(v,1).overrideRaisedBackgroundColor;
    const currVal_6:any = import0.ɵnov(v,1).overrideRaisedForegroundColor;
    const currVal_7:any = import0.ɵnov(v,1).disabled;
    const currVal_8:any = import0.ɵnov(v,1).invisible;
    const currVal_9:any = import0.ɵnov(v,1).hovered;
    const currVal_10:any = import0.ɵnov(v,1).native;
    const currVal_11:any = import0.ɵnov(v,1).button;
    const currVal_12:any = import0.ɵnov(v,1).firstTier;
    const currVal_13:any = import0.ɵnov(v,1).secondTier;
    const currVal_14:any = import0.ɵnov(v,1).highProminence;
    const currVal_15:any = import0.ɵnov(v,1).lowProminence;
    const currVal_16:any = import0.ɵnov(v,1).affirmativeConnotation;
    const currVal_17:any = import0.ɵnov(v,1).dissuasiveConnotation;
    const currVal_18:any = import0.ɵnov(v,1).negativeConnotation;
    const currVal_19:any = import0.ɵnov(v,1).squareShape;
    const currVal_20:any = import0.ɵnov(v,1).roundedShape;
    const currVal_21:any = import0.ɵnov(v,1).ovalShape;
    const currVal_22:any = import0.ɵnov(v,1).flatStyle;
    const currVal_23:any = import0.ɵnov(v,1).outlineStyle;
    const currVal_24:any = import0.ɵnov(v,1).raisedStyle;
    const currVal_25:any = import0.ɵnov(v,1).verticalLayout;
    const currVal_26:any = import0.ɵnov(v,1).horizontalLayout;
    ck(v,0,1,[
      currVal_0,
      currVal_1,
      currVal_2,
      currVal_3,
      currVal_4,
      currVal_5,
      currVal_6,
      currVal_7,
      currVal_8,
      currVal_9,
      currVal_10,
      currVal_11,
      currVal_12,
      currVal_13,
      currVal_14,
      currVal_15,
      currVal_16,
      currVal_17,
      currVal_18,
      currVal_19,
      currVal_20,
      currVal_21,
      currVal_22,
      currVal_23,
      currVal_24,
      currVal_25,
      currVal_26
    ]
    );
  });
}
function View_QuickPayPanelComponent_3(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-card-brand',[[
        'class',
        'card-brand'
      ]
    ],(null as any),(null as any),(null as any),import6.View_CardBrandComponent_0,import6.RenderType_CardBrandComponent)),
      import0.ɵdid(573440,(null as any),0,import7.CardBrandComponent,([] as any[]),{brand: [
        0,
        'brand'
      ]
    },(null as any))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.paymentModel.cardBrand;
    ck(v,1,0,currVal_0);
  },(null as any));
}
function View_QuickPayPanelComponent_4(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[
      [
        'class',
        'quick-pay-button-card-last-4'
      ]
      ,
      [
        'slot',
        'after-label'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.paymentModel.cardLast4;
    ck(v,1,0,currVal_0);
  });
}
function View_QuickPayPanelComponent_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),9,'woa-button',[[
        'class',
        'quick-pay-button credit-card'
      ]
    ],[
      [
        2,
        'override-flat-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-flat-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-border-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'invisible',
        (null as any)
      ]
      ,
      [
        2,
        'hovered',
        (null as any)
      ]
      ,
      [
        2,
        'native',
        (null as any)
      ]
      ,
      [
        2,
        'woa-button',
        (null as any)
      ]
      ,
      [
        2,
        'tier-first',
        (null as any)
      ]
      ,
      [
        2,
        'tier-second',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-high',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-low',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-affirmative',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-dissuasive',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-negative',
        (null as any)
      ]
      ,
      [
        2,
        'shape-square',
        (null as any)
      ]
      ,
      [
        2,
        'shape-rounded',
        (null as any)
      ]
      ,
      [
        2,
        'shape-oval',
        (null as any)
      ]
      ,
      [
        2,
        'style-flat',
        (null as any)
      ]
      ,
      [
        2,
        'style-outline',
        (null as any)
      ]
      ,
      [
        2,
        'style-raised',
        (null as any)
      ]
      ,
      [
        2,
        'layout-vertical',
        (null as any)
      ]
      ,
      [
        2,
        'layout-horizontal',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('click' === en)) {
        const pd_1:any = ((<any>co.pay.emit(co.PaymentType.SAVED_CREDIT_CARD)) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import1.View_ButtonComponent_0,import1.RenderType_ButtonComponent)),
    import0.ɵdid(245760,(null as any),0,import2.ButtonComponent,[
      import0.ElementRef,
      import3.SessionModel,
      import0.ChangeDetectorRef,
      import4.ResponsiveService
    ]
    ,{
      label: [
        0,
        'label'
      ]
      ,
      showSpinner: [
        1,
        'showSpinner'
      ]
      ,
      disabled: [
        2,
        'disabled'
      ]

    }
    ,(null as any)),
    import0.ɵpid(131072,import5.AsyncPipe,[import0.ChangeDetectorRef]),
    (l()(),import0.ɵted(0,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),0,1,(null as any),View_QuickPayPanelComponent_3)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(0,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),1,1,(null as any),View_QuickPayPanelComponent_4)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(0,['\n']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_27:any = (co.showSpinner? 'woa.message.order.initiating': 'woa.button.checkout.payWithCard');
    const currVal_28:any = co.showSpinner;
    const currVal_29:any = ((co.disabled || co.sessionModel.timeTestMode) || (import0.ɵunv(v,1,2,import0.ɵnov(v,2).transform(co.OrderEvents.orderInitiationStatus$)) === co.OrderInitiationStatus.INITIATING));
    ck(v,1,0,currVal_27,currVal_28,currVal_29);
    const currVal_30:boolean = !co.showSpinner;
    ck(v,5,0,currVal_30);
    const currVal_31:boolean = !co.showSpinner;
    ck(v,8,0,currVal_31);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).overrideFlatBackgroundColor;
    const currVal_1:any = import0.ɵnov(v,1).overrideFlatForegroundColor;
    const currVal_2:any = import0.ɵnov(v,1).overrideOutlineBackgroundColor;
    const currVal_3:any = import0.ɵnov(v,1).overrideOutlineForegroundColor;
    const currVal_4:any = import0.ɵnov(v,1).overrideOutlineBorderColor;
    const currVal_5:any = import0.ɵnov(v,1).overrideRaisedBackgroundColor;
    const currVal_6:any = import0.ɵnov(v,1).overrideRaisedForegroundColor;
    const currVal_7:any = import0.ɵnov(v,1).disabled;
    const currVal_8:any = import0.ɵnov(v,1).invisible;
    const currVal_9:any = import0.ɵnov(v,1).hovered;
    const currVal_10:any = import0.ɵnov(v,1).native;
    const currVal_11:any = import0.ɵnov(v,1).button;
    const currVal_12:any = import0.ɵnov(v,1).firstTier;
    const currVal_13:any = import0.ɵnov(v,1).secondTier;
    const currVal_14:any = import0.ɵnov(v,1).highProminence;
    const currVal_15:any = import0.ɵnov(v,1).lowProminence;
    const currVal_16:any = import0.ɵnov(v,1).affirmativeConnotation;
    const currVal_17:any = import0.ɵnov(v,1).dissuasiveConnotation;
    const currVal_18:any = import0.ɵnov(v,1).negativeConnotation;
    const currVal_19:any = import0.ɵnov(v,1).squareShape;
    const currVal_20:any = import0.ɵnov(v,1).roundedShape;
    const currVal_21:any = import0.ɵnov(v,1).ovalShape;
    const currVal_22:any = import0.ɵnov(v,1).flatStyle;
    const currVal_23:any = import0.ɵnov(v,1).outlineStyle;
    const currVal_24:any = import0.ɵnov(v,1).raisedStyle;
    const currVal_25:any = import0.ɵnov(v,1).verticalLayout;
    const currVal_26:any = import0.ɵnov(v,1).horizontalLayout;
    ck(v,0,1,[
      currVal_0,
      currVal_1,
      currVal_2,
      currVal_3,
      currVal_4,
      currVal_5,
      currVal_6,
      currVal_7,
      currVal_8,
      currVal_9,
      currVal_10,
      currVal_11,
      currVal_12,
      currVal_13,
      currVal_14,
      currVal_15,
      currVal_16,
      currVal_17,
      currVal_18,
      currVal_19,
      currVal_20,
      currVal_21,
      currVal_22,
      currVal_23,
      currVal_24,
      currVal_25,
      currVal_26
    ]
    );
  });
}
function View_QuickPayPanelComponent_5(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'woa-apple-pay-button',[[
        'class',
        'quick-pay-button credit-card apple-pay'
      ]
    ],[
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'woa-button',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'pay'
      ]
      ,
      [
        (null as any),
        'click'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('pay' === en)) {
        const pd_1:any = ((<any>co.pay.emit(co.PaymentType.APPLE_PAY)) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import8.View_ApplePayButtonComponent_0,import8.RenderType_ApplePayButtonComponent)),
    import0.ɵdid(4964352,(null as any),0,import9.ApplePayButtonComponent,[
      import0.ElementRef,
      import10.PaymentModel,
      import0.ChangeDetectorRef
    ]
    ,{
      type: [
        0,
        'type'
      ]
      ,
      disabled: [
        1,
        'disabled'
      ]
      ,
      showSpinner: [
        2,
        'showSpinner'
      ]

    }
    ,{pay: 'pay'}),
    import0.ɵpid(131072,import5.AsyncPipe,[import0.ChangeDetectorRef]),
    import0.ɵpid(131072,import5.AsyncPipe,[import0.ChangeDetectorRef]),
    import0.ɵpid(131072,import5.AsyncPipe,[import0.ChangeDetectorRef])
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_2:any = co.applePayType;
    const currVal_3:any = (((co.disabled || co.sessionModel.timeTestMode) || import0.ɵunv(v,1,1,import0.ɵnov(v,2).transform(co.PaymentEvents.isSubmittingWalletPayment$))) || (import0.ɵunv(v,1,1,import0.ɵnov(v,3).transform(co.OrderEvents.orderInitiationStatus$)) === co.OrderInitiationStatus.INITIATING));
    const currVal_4:any = (co.showSpinner || import0.ɵunv(v,1,2,import0.ɵnov(v,4).transform(co.PaymentEvents.isSubmittingWalletPayment$)));
    ck(v,1,0,currVal_2,currVal_3,currVal_4);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).disabled;
    const currVal_1:any = import0.ɵnov(v,1).button;
    ck(v,0,0,currVal_0,currVal_1);
  });
}
function View_QuickPayPanelComponent_6(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'woa-google-pay-button',[[
        'class',
        'quick-pay-button google-pay'
      ]
    ],[
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'woa-button',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'pay'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('pay' === en)) {
        const pd_0:any = ((<any>co.pay.emit(co.PaymentType.GOOGLE_PAY)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import11.View_GooglePayButtonComponent_0,import11.RenderType_GooglePayButtonComponent)),
    import0.ɵdid(4898816,(null as any),0,import12.GooglePayButtonComponent,[
      import0.ElementRef,
      import10.PaymentModel,
      import0.ChangeDetectorRef,
      import3.SessionModel
    ]
    ,{
      type: [
        0,
        'type'
      ]
      ,
      disabled: [
        1,
        'disabled'
      ]
      ,
      showSpinner: [
        2,
        'showSpinner'
      ]

    }
    ,{pay: 'pay'}),
    import0.ɵpid(131072,import5.AsyncPipe,[import0.ChangeDetectorRef]),
    import0.ɵpid(131072,import5.AsyncPipe,[import0.ChangeDetectorRef]),
    import0.ɵpid(131072,import5.AsyncPipe,[import0.ChangeDetectorRef])
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_2:any = co.googlePayType;
    const currVal_3:any = (((co.disabled || co.sessionModel.timeTestMode) || import0.ɵunv(v,1,1,import0.ɵnov(v,2).transform(co.PaymentEvents.isSubmittingWalletPayment$))) || (import0.ɵunv(v,1,1,import0.ɵnov(v,3).transform(co.OrderEvents.orderInitiationStatus$)) === co.OrderInitiationStatus.INITIATING));
    const currVal_4:any = (co.showSpinner || import0.ɵunv(v,1,2,import0.ɵnov(v,4).transform(co.PaymentEvents.isSubmittingWalletPayment$)));
    ck(v,1,0,currVal_2,currVal_3,currVal_4);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).disabled;
    const currVal_1:any = import0.ɵnov(v,1).button;
    ck(v,0,0,currVal_0,currVal_1);
  });
}
export function View_QuickPayPanelComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    import0.ɵpid(0,import13.PossessivePipe,([] as any[])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_QuickPayPanelComponent_1)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_QuickPayPanelComponent_2)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_QuickPayPanelComponent_5)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_QuickPayPanelComponent_6)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import14.QuickPayPanelComponent = v.component;
    const currVal_0:any = (co.orderModel.getQuickPayType(co.requireLogin) === co.PaymentType.GROUP_PAY);
    ck(v,2,0,currVal_0);
    const currVal_1:any = (co.orderModel.getQuickPayType(co.requireLogin) === co.PaymentType.SAVED_CREDIT_CARD);
    ck(v,5,0,currVal_1);
    const currVal_2:any = (co.orderModel.getQuickPayType(co.requireLogin) === co.PaymentType.APPLE_PAY);
    ck(v,8,0,currVal_2);
    const currVal_3:any = (co.orderModel.getQuickPayType(co.requireLogin) === co.PaymentType.GOOGLE_PAY);
    ck(v,11,0,currVal_3);
  },(null as any));
}
function View_QuickPayPanelComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-quick-pay-panel',([] as any[]),(null as any),(null as any),(null as any),View_QuickPayPanelComponent_0,RenderType_QuickPayPanelComponent)),
    import0.ɵdid(49152,(null as any),0,import14.QuickPayPanelComponent,[
      import15.OrderModel,
      import10.PaymentModel,
      import3.SessionModel,
      import16.GroupOrderModel
    ]
    ,(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export const QuickPayPanelComponentNgFactory:import0.ComponentFactory<import14.QuickPayPanelComponent> = import0.ɵccf('woa-quick-pay-panel',import14.QuickPayPanelComponent,View_QuickPayPanelComponent_Host_0,{
  requireLogin: 'requireLogin',
  showSpinner: 'showSpinner',
  disabled: 'disabled',
  applePayType: 'applePayType',
  googlePayType: 'googlePayType'
}
,{pay: 'pay'},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/app/ordering-page/quick-pay-panel/quick-pay-panel.component.ngfactory.ts